import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/inspect.vue
var o = {
	name: "DtIconInspect",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--inspect"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Inspect",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1.44 1.44A1.5 1.5 0 0 1 2.5 1h7A1.5 1.5 0 0 1 11 2.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 1 9.5v-7c0-.398.158-.78.44-1.06Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.646 5.646a.5.5 0 0 1 .54-.11l5 2a.5.5 0 0 1-.002.929l-1.949.77-.77 1.949a.5.5 0 0 1-.93.002l-2-5a.5.5 0 0 1 .111-.54Zm1.252 1.252 1.1 2.749.387-.98a.5.5 0 0 1 .281-.282l.98-.388-2.748-1.1Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=inspect.js.map